import { useMemo } from 'react';
import { AsyncComponentHookResult } from '../../../../Types/ComponentHookResult';
import { useAchRelationshipsQuery, AchRelationshipDTO } from '../../api/useAchRelationshipsQuery';
import { useMaxAchRelationshipsQuery } from '../../api/useMaxAchRelationshipsQuery';
import { combineQueryResults } from '../../../../CommonUtils/combineQueryResults';

interface Data {
  relationships: AchRelationshipDTO[];
  maxRelationships: number;
}

export const useManageAccounts = (): AsyncComponentHookResult<Data> => {
  const relationshipsQueryInfo = useAchRelationshipsQuery();
  const maxRelationshipsQueryInfo = useMaxAchRelationshipsQuery();

  const data = useMemo(() => {
    if (!relationshipsQueryInfo.data || !maxRelationshipsQueryInfo.data) {
      return null;
    }

    return {
      relationships: relationshipsQueryInfo.data,
      maxRelationships: maxRelationshipsQueryInfo.data,
    };
  }, [maxRelationshipsQueryInfo.data, relationshipsQueryInfo.data]);

  return {
    ...combineQueryResults([relationshipsQueryInfo, maxRelationshipsQueryInfo]),
    data,
  };
};
